import lc116Metadata from './data/metadata.json';
import type { Lc116DataVersion } from './types.js';

export const LC116_DATA_VERSION: Lc116DataVersion = lc116Metadata as Lc116DataVersion;
